/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaInfoCircle, FaRegCalendar } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { userSetState } from '~/store/modules/user/actions';
import history from '~/services/history';
import confirm from '~/components/Confirm';

import {
  WrapPage,
  Container,
  BannerTitle,
  BannerSubtitle,
  BannerLogo,
  Label,
  InputName,
  InputLink,
  InputData,
  InputWrap,
  InputBox,
  Legend,
  ButtonNext,
  ButtonCancel,
} from './styles';

function Step1({ theme }) {
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [initialDate, setInitialDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [link, setLink] = useState('');

  useEffect(() => {
    dispatch(userSetState({ wizardProgress: 50, backgroundImage: null }));
  }, []);

  return (
    <WrapPage>
      <Container>
        <BannerTitle>
          <Link to="/propagate">
            <FaChevronLeft size={14} />
          </Link>
          Banner
        </BannerTitle>
        <BannerSubtitle>PASSO 1/2</BannerSubtitle>
        <BannerLogo />
        <InputWrap>
          <InputBox>
            <Label>
              Nome da campanha
              <FaInfoCircle
                data-tip="Escolha um nome que seja de fácil identificação da campanha."
                data-for="tooltip-provider"
              />
            </Label>
            <InputName
              name="name"
              type="text"
              placeholder="Digite o nome da campanha"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </InputBox>
        </InputWrap>
        <Legend style={{ marginBottom: 30 }}>
          Exemplo: "Promoções de Natal". Seu cliente não irá visualizar esse
          item.
        </Legend>
        <InputWrap style={{ marginBottom: 30 }}>
          <InputBox>
            <Label>
              Início da campanha:
              <FaInfoCircle
                data-tip="Data de início de veiculação da campanha."
                data-for="tooltip-provider"
              />
            </Label>
            <InputData
              name="init-date"
              type="text"
              placeholder="99/99/9999 às 00:00h"
              value={initialDate}
              onChange={setInitialDate}
              icon={FaRegCalendar}
              responseFormat="YYYY-MM-DD HH:mm:ss"
            />
          </InputBox>
        </InputWrap>
        <InputWrap style={{ marginBottom: 30 }}>
          <InputBox>
            <Label>
              Fim da campanha:
              <FaInfoCircle
                data-tip="Data de conclusão de veiculação da campanha."
                data-for="tooltip-provider"
              />
            </Label>
            <InputData
              name="final-date"
              type="text"
              placeholder="99/99/9999 às 00:00h"
              value={finalDate}
              onChange={setFinalDate}
              icon={FaRegCalendar}
              responseFormat="YYYY-MM-DD HH:mm:ss"
            />
          </InputBox>
        </InputWrap>
        <InputWrap>
          <InputBox>
            <Label>
              Link da campanha
              <FaInfoCircle
                data-tip="Link que irá direcionar o seu cliente."
                data-for="tooltip-provider"
              />
            </Label>
            <InputLink
              name="link"
              type="text"
              placeholder="Digite o link da campanha"
              value={link}
              onChange={(e) => {
                setLink(e.target.value);
              }}
            />
          </InputBox>
        </InputWrap>
        <Legend style={{ marginBottom: 30 }}>
          Exemplo: Seu site, sua rede social.
        </Legend>
        <InputWrap style={{ marginBottom: 30 }}>
          <ButtonNext
            title="Avançar"
            onClick={() => {
              confirm({
                theme,
                title: 'Atenção',
                close: false,
                message:
                  'Funcionalidade de URL de campanha está disponível somente para dispositivos IOS',
                button: {
                  label: 'Ok, entendi',
                  onClick: () => history.push('/propagate/banner/step2'),
                },
              });
            }}
          />
          <ButtonCancel
            title="Cancelar"
            onClick={() => history.push('/propagate')}
          />
        </InputWrap>

        <ReactTooltip
          place="right"
          backgroundColor="#FFFFFF"
          textColor="#323232"
          border
          borderColor="#d1d1d1"
          className="tooltip-wrap"
          id="tooltip-provider"
        />
      </Container>
    </WrapPage>
  );
}

Step1.propTypes = {
  theme: PropTypes.shape().isRequired,
};

export default withTheme(Step1);
